import instance from '../instance';
import getLiveElement from './get-live-element';

const getLiveElementLastChild = (elementId) => {
  const liveElement = getLiveElement(elementId);
  if (!liveElement) return null;

  const lastChildId = instance.driver.referenceMap.getLastChildReferenceId(liveElement);
  if (!lastChildId) return null;

  return getLiveElement(lastChildId);
};

export default getLiveElementLastChild;
